// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"gq-z","slideIn":"hq-z"};